import { Component, input } from '@angular/core';
import { LineInputs } from '@charts';
import { LineChartComponent } from "../line-chart";

@Component({
  selector: 'ui-rsabt-wave-quality-frequency-chart',
  imports: [LineChartComponent],
  template: ` <ui-line-chart [lineInputs]="lineInputs()" /> `,
})
export class RsabtWaveQualityFrequencyChartComponent {
  lineInputs = input.required<LineInputs>();
}
